import { useAtomValue } from "jotai";
import { useQuery } from "@tanstack/react-query";

import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import API from "../../api/API";

export interface GlobalLists {
  id: string;
  _id: string;
  Name: string;
  APIName: string;
  Description: string;
  Created: string;
  LastUpdated: string;
  Variables: GlobalListsVariables[];
}

interface GlobalListsVariables {
  Name: string;
  Value: string;
  Type: "string" | "number";
  id: string;
}

const useGlobalLists = (enabled = true) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);
  const isSupportal = window.location.pathname.startsWith("/supportal");

  const globalLists = useQuery<GlobalLists[]>({
    queryKey: ["globalLists"],
    queryFn: () =>
      API.getGlobalVariableLists().then((data) => data?.data?.data?.lists),
    enabled: (queriesEnabled && enabled) || isSupportal,
    staleTime: Infinity,
  });

  return {
    globalLists: globalLists.data,
    globalListsLoading:
      globalLists.isLoading || (!queriesEnabled && !isSupportal),
  };
};

export default useGlobalLists;
